import { render } from "./SmartSlider.vue?vue&type=template&id=f2008c28&scoped=true"
import script from "./SmartSlider.vue?vue&type=script&lang=js"
export * from "./SmartSlider.vue?vue&type=script&lang=js"

import "./SmartSlider.vue?vue&type=style&index=0&id=f2008c28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2008c28"]])

export default __exports__